/* created by CoolGuy on 2018/11/4
 * copy from AgreementAction
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('allocate');
const ALLOCATION_DETAIL = "ALLOCATION_DETAIL";
const ALLOCATION_ORDER = "ALLOCATION_ORDER";
const ALLOCATION_ORDER_DETAIL = "ALLOCATION_ORDER_DETAIL";
const ALLOCATION_SORT = "ALLOCATION_SORT";
const ALLOCATION_POST = "ALLOCATION_POST";
const ALLOCATION_CANCEL = "ALLOCATION_CANCEL";
const ALLOCATION_UPDATE = "ALLOCATION_UPDATE";
// 注意，这个是用来设置右侧的calendar的
const ALLOCATION_SET_CALENDAR_ID = "ALLOCATION_SET_CALENDAR_ID";
// 这是用来设置当前弹出的 分配框的ID的
const ALLOCATION_SET_ALLOCATION_ID = "ALLOCATION_SET_ALLOCATION_ID";
const ALLOCATION_USER = "ALLOCATION_USER";
const ALLOCATION_SET_CURRENT_TIME = "ALLOCATION_SET_CURRENT_TIME";
const ALLOCATION_EMPTY_LIST = "ALLOCATION_EMPTY_LIST";
const ALLOCATION_EMPTY_SORT_LIST = "ALLOCATION_EMPTY_SORT_LIST";
const ALLOCATION_EMPTY_CURRENT_ALLOCATION = "ALLOCATION_EMPTY_CURRENT_ALLOCATION";
const ALLOCATION_CHECK_COVER = "ALLOCATION_CHECK_COVER";

export default {
    ALLOCATION_DETAIL,
    allocationDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:ALLOCATION_DETAIL,
                data,
            })
        })
    },
    // 获取指定订单下已分配成员
    ALLOCATION_ORDER,
    allocationOrder:(orderid,oper)=>
        ajaxCommon({
            api:TheApi('get')('order'),
            data:{orderid,oper},
            success:(data)=>({
                type:ALLOCATION_ORDER,
                oper,
                data,
            }),
        }),
    ALLOCATION_ORDER_DETAIL,
    allocationOrderDetail:(id)=>
        ajaxCommon({
            api:TheApi('get')('orderdetail'),
            data:{orderid:id},
            success:(data)=>({
                type:ALLOCATION_ORDER_DETAIL,
                data,
            }),
        }),
    ALLOCATION_SORT,
    allocationSort:({orderid,starttime,endtime,oper,search})=>
        ajaxCommon({
            api:TheApi('get')('sort'),
            data:{orderid,starttime,endtime,oper,search},
            success:(data)=>({
                type:ALLOCATION_SORT,
                oper,
                data,
            }),

        }),
    ALLOCATION_POST,
    allocationPost:(params,oper)=>
        ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:ALLOCATION_POST,
                adminid:params.adminid,
                data,
                oper,
            }),
        }),
    // 取消分配
    ALLOCATION_CANCEL,
    allocationCancel:(one,oper)=>
        ajaxCommon({
            api:TheApi('delete')(one.id),
            success:(data)=>({
                type:ALLOCATION_CANCEL,
                one,
                oper,
                data,
            }),
        }),
    ALLOCATION_UPDATE,
    allocationUpdate:(params,per)=>
        ajaxCommon({
            api:TheApi('put')(params.id),
            data:params,
            success:(data)=>({
                type:ALLOCATION_UPDATE,
                data,
                per,
            }),
        }),
    ALLOCATION_CHECK_COVER,
    checkAllocateCover:(params,per)=>
        ajaxCommon({
            api:TheApi('post')('checkcover'),
            data:params,
            success:(data)=>({
                type:ALLOCATION_UPDATE,
                data,
                per,
            }),
        }),
    ALLOCATION_SET_CALENDAR_ID,
    allocationSetCalendarId:(id)=>({
        type:ALLOCATION_SET_CALENDAR_ID,
        id,
    }),
    ALLOCATION_SET_ALLOCATION_ID,
    allocationSetAllocationId:(id)=>({
        type:ALLOCATION_SET_ALLOCATION_ID,
        id,
    }),
    ALLOCATION_USER,
    allocationUser:({adminid,starttime,endtime})=>
        ajaxCommon({
            api:TheApi('get')('user'),
            data:{adminid,starttime,endtime},
            success:(data)=>({
                type:ALLOCATION_USER,
                adminid,
                data,
            }),
        }),
    ALLOCATION_SET_CURRENT_TIME,
    allocationSetCurrentTime:(start,end)=>({
        type:ALLOCATION_SET_CURRENT_TIME,
        start,
        end,
    }),
    ALLOCATION_EMPTY_LIST,
    allocationEmptyList:()=>({
        type:ALLOCATION_EMPTY_LIST,
    }),
    ALLOCATION_EMPTY_SORT_LIST,
    allocationEmptySortList:(oper)=>({
        type:ALLOCATION_EMPTY_SORT_LIST,
        oper,
    }),
    ALLOCATION_EMPTY_CURRENT_ALLOCATION,
    allocationEmptyCurrentAllocation:()=>({
        type:ALLOCATION_EMPTY_CURRENT_ALLOCATION,
    }),
}



// WEBPACK FOOTER //
// ./src/actions/AllocationAction.js